<div class="edit-comment form-horizontal">
    <div class="comment-modal-body">
        @if (areCommentTypesAvailable) {
            <div class="mb-4 row">
                <label for="comment-type-selection" class="col-md-2 control-label">Type</label>
                <div class="col-md-10">
                    <ws-select
                        id="comment-type-selection"
                        [(ngModel)]="updateComment.commentTypeID"
                        [options]="commentTypes"
                        labelProperty="name"
                        valueProperty="id"
                        [disabled]="!isNewComment || entityData.disableCommentTypeSelection">
                    </ws-select>
                </div>
            </div>
        }
        @if (yearIsRelevant) {
            <div class="mb-4 row">
                <label for="comment-year-selection" class="col-md-2 control-label">Year</label>
                <div class="col-md-10">
                    <ws-select id="comment-year-selection"
                                [(ngModel)]="updateComment.year"
                                [options]="availableYears"
                                [isPrimitive]="true"
                                [disabled]="yearDisabled()"
                                [required]="updateComment.commentTypeID === 3">
                    </ws-select>
                </div>
            </div>
        }
        <div class="mb-4 row">
            <label for="comment-title-input" class="col-md-2 control-label">Title</label>
            <div class="col-md-10">
                <input type="text"
                        required
                        maxlength="255"
                        class="form-control"
                        id="comment-title-input"
                        [(ngModel)]="updateComment.title"/>
            </div>
        </div>
        <div class="mb-4 row">
            <label for="comment-description-input" class="col-md-2 control-label">Description</label>
            <div class="col-md-10">
        <textarea class="form-control"
                    maxlength="10000"
                    id="comment-description-input"
                    [(ngModel)]="updateComment.description"
                    rows="10"
                    style="resize: none;">
        </textarea>
            </div>
        </div>
        @if (hasInstancePrivateView) {
            <div class="mb-4 row">
                <label for="comment-ryan-permissions" class="col-md-12" style="font-weight: normal">
                    <input id="comment-ryan-permissions"
                            [(ngModel)]="updateComment.isRyanInternal"
                            type="checkbox">
                    Only visible to
                    @if (isSingleRyanInstance) {
                        Ryan
                    }
                    @if (!isSingleRyanInstance) {
                        Internal
                    }
                    personnel
                </label>
            </div>
        }
        @if(yearIsRelevant && !!updateComment.year){
            <div class="row mb-4">
                <label for="comment-pin" class="col-12" style="font-weight: normal">
                    <input id="comment-pin" [(ngModel)]="updateComment.isPinned" type="checkbox">
                    Pin Comment
                </label>
            </div>
        }
        @if (!isNewComment) {
            <div style="margin-top:20px;">
                <button type="button" class="ace-btn btn-sm btn-primary btn-danger" (click)="deleteComment()">
                    Delete Comment
                </button>
            </div>
        }
    </div>
    <div class="ace-button-container comment-edit-footer">
        @if (isNewComment) {
            <button type="button"
                    class="ace-btn btn-primary"
                    [disabled]="loading || !valid"
                    (click)="submitEditForm()">
                Create Comment
            </button>
        }
        @if (!isNewComment) {
            <button type="button"
                    class="ace-btn btn-primary"
                    [disabled]="loading || !valid"
                    (click)="submitEditForm()">
                Save Comment
            </button>
        }
        <button type="button"
                class="ace-btn btn-secondary"
                (click)="cancelEdit.emit()"
                [disabled]="loading">
            Cancel
        </button>
    </div>
</div>